import React from 'react';

const TableHeader = () => (
  <thead className="bg-gray-50 dark:bg-slate-800">
    <tr>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap">
        Issue & Status
      </th>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap">
        Author & Assignee
      </th>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap">
        Project
      </th>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap">
        Logged Hours
      </th>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap">
        Estimated
      </th>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap">
        Date & Time
      </th>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap">
        Variance
      </th>
      <th className="px-3 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider">
        Description
      </th>
    </tr>
  </thead>
);

export default TableHeader;

